import React from 'react'

import Button from '@react/react-spectrum/Button'
import Dialog from '@react/react-spectrum/Dialog'
import ModalTrigger from '@react/react-spectrum/ModalTrigger'
import { success } from '@react/react-spectrum/Toast'

const copyText = text => {
  navigator.clipboard.writeText(text)
  success('Content copied to clipboard')
}

const JsonViewer = ({ content, buttonLabel, dialogTitle, indent }) => {
  return (
    <ModalTrigger>
      <Button
        onClick={e => {
          e.preventDefault()
        }}
        modaltrigger
      >
        {buttonLabel || 'Sample Content'}
      </Button>
      <Dialog
        modalContent
        title={dialogTitle || 'Sample Content'}
        cancelLabel='Close'
        confirmLabel='Copy Content'
        onConfirm={() => copyText(JSON.stringify(content, null, indent || 2))}
        size='S'
      >
        <div>
          <pre>{JSON.stringify(content, null, indent || 2)}</pre>
        </div>
      </Dialog>
    </ModalTrigger>
  )
}

export default JsonViewer
